class restoreSeatplan {
    constructor(Alert, $http, $state) {

        this.key = 'restore-seatplan';
        this.title = 'Restore';
        this.level = 'archived-highlight';
        this.icon = 'fal fa-undo';
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
    }

    action(seatplan, vm) {
        this.alert.confirm({
            title: `Restoring ${ seatplan.title}`,
            message: 'Are you sure you want to restore this seatplan? This cannot be undone!',
            confirmBtn: 'Restore'
        }).then(() => {
            return this.api.put(`seatplans/${ seatplan.id }/restore`)
                .then(() => {
                    this.state.reload();
                    if (vm.store) {
                        return vm.store.dispatch('getData');
                    }
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.seatplans')
    .factory('restoreSeatplan', [
        'Alert',
        '$http',
        '$state',
        (Alert, $http, $state) => new restoreSeatplan(Alert, $http, $state)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/seatplans/workflows/restore-seatplan.js